<template>
    <div class="view sign-in uk-flex uk-flex-middle uk-flex-center">
        <div class="uk-container uk-width-1-1 uk-padding-large">
            <div class="uk-width-1-3@m uk-align-center">
                <h1 class="uk-text-center uk-margin-large-bottom">
                    {{ appTitle }}
                </h1>
                <div
                    v-if="loginFailed"
                    id="system-message"
                    class="uk-grid-match uk-margin-top uk-margin-bottom"
                >
                    <div class="uk-width-1-1">
                        <div
                            class="uk-alert uk-alert-danger"
                        >
                            {{ error }}
                        </div>
                    </div>
                </div>
                <div class="uk-card uk-card-medium">
                    <div class="panel uk-card-body">
                        <h3>Sign in</h3>
                        <sign-in-form
                            :show-error-on-blur-only="true"
                            :override-on-login-success-redirect="true"
                            @onLoginSuccessRedirect="onLoginSuccess"
                            @setLoginFailed="setLoginFailed"
                            @setLoginError="setLoginError"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import SignInForm from "@strangeanimals/common-vue-components/src/components/forms/SignInForm";
import { getConfig } from "@strangeanimals/common-vue-components/src/helpers/helpers";
import { mapActions, mapGetters } from 'vuex';
import { DateTime } from 'luxon';

export default {
    components: { SignInForm },
    data: function () {
        return {
            loginFailed: false,
            loginError: null,
        };
    },
    computed: {
        ...mapGetters({
            targetLink: 'targetLink',
            targetQuery: 'targetQuery',
        }),
        appTitle() {
            return getConfig().title;
        },
        error() {
            return this.loginError ? this.loginError : "Sorry, you do not have permission to access Customer Payments. If you believe this is an error, please contact the IT Service Desk.";
        }
    },
    methods: {
        ...mapActions({
            updateTokenCreatedTimestamp: 'updateTokenCreatedTimestamp'
        }),
        setLoginFailed(status) {
            this.loginFailed = status;
        },
        setLoginError(error) {
            this.loginError = error;
        },
        onLoginSuccess() {
            this.updateTokenCreatedTimestamp(DateTime.utc().toISO());
            if (this.targetLink !== null) {
                this.$router.push({
                    path: this.targetLink,
                    query: this.targetQuery
                });
            } else {
                this.$router.push({
                    name: 'Dashboard'
                })
            }
        }
    }
};
</script>